import { path, httpService } from '@commons';

/////////////////////////////////////////////////////////////////////////////////
const args = { ...path, path: '/tracking/module' };
/////////////////////////////////////////////////////////////////////////////////

export function createTrackModLog(payload) {
  return httpService.post({ ...args, args: '/track' }, payload);
}
